import { useAccount } from 'wagmi';
import { useWeb3Modal, useWeb3ModalState } from '@web3modal/wagmi/dist/esm/exports/react';
import { useClientContext } from 'app/contexts';

const useWeb3ModalWithCallback = (callbackOnConnectWallet) => {
  const {
    methods: { callContract },
  } = useClientContext();
  const { open: openWeb3Modal, close } = useWeb3Modal();
  const { open: isWeb3ModalOpen } = useWeb3ModalState();
  const account = useAccount({
    onConnect() {
      callbackOnConnectWallet();
      close();
    },
  });
  const { isConnected, address } = account;

  const onConnectWallet = (callback) => {
    if (!address || !isConnected) {
      openWeb3Modal();
      if (callback) callback();
    }
    return isConnected;
  };

  return { callContract, openWeb3Modal, close, account, onConnectWallet, isWeb3ModalOpen };
};

export default useWeb3ModalWithCallback;
